import { Payable } from "@wingspanhq/wingspan-api-sdk";

/**
 * Whether the acting account authored this payable — the payer raised it itself
 * rather than receiving it from the contractor.
 *
 * v1 answered this from `userRoles.ownerIds` (which carried the creating side);
 * v3 names the creating account on `actors.createdBy`. Authorship that can't be
 * resolved reads as "not the creator", matching v1's empty-owners fallback, so an
 * action gated on this stays offered rather than silently disappearing.
 */
export const selectorIsPayableCreator = (params: {
  payable: Payable;
  accountId?: string;
}): boolean =>
  !!params.accountId && params.payable.actors?.createdBy === params.accountId;
